import { createContext, type ReactNode, useContext } from "react";
import type { LandingContent } from "./types";

const LandingContentContext = createContext<LandingContent | null>(null);

export function LandingContentProvider({
	content,
	children,
}: {
	content: LandingContent;
	children: ReactNode;
}) {
	return (
		<LandingContentContext.Provider value={content}>{children}</LandingContentContext.Provider>
	);
}

export function useLandingContent(): LandingContent {
	const content = useContext(LandingContentContext);
	if (!content) throw new Error("Landing content provider is required");
	return content;
}
